export const PROFILE = {
  name: "PIYUSH",
  last: "SONI",
  fullName: "PIYUSH SONI",
  subtitle: "BCA student building AI-powered SaaS products.",
  email: "piyushsoni0900@gmail.com",
  linkedin: "https://www.linkedin.com/in/piyush-soni01/",
  github: "https://github.com/", // TODO: replace with Piyush's GitHub URL
};

export const STATS = [
  { value: 3, display: "03", label: "Products built", sub: "Real tools, in real use" },
  { value: 2028, display: "2028", label: "BCA · graduating class", sub: "Building while learning" },
  { value: 1, display: "01", label: "Google certified", sub: "Digital Marketing & E-commerce" },
  { value: 3, display: "03", label: "Obsessions", sub: "AI · Building · Entrepreneurship" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "I ship, then I learn.",
    body: "Every project starts as a real problem someone actually has. I'd rather put a rough tool in someone's hands today than polish a prototype nobody uses.",
  },
  {
    n: "02",
    title: "Software should feel invisible.",
    body: "The best products get out of the way. Excel imports, WhatsApp shares, voice commands — meet people where they already work.",
  },
  {
    n: "03",
    title: "AI is a teammate, not a gimmick.",
    body: "Agents, OCR, automation — I use AI to remove the boring parts so small businesses can move faster without a bigger team.",
  },
];

export const PILLARS = [
  {
    n: "01",
    title: "Web Development",
    tag: "Ship / Iterate",
    body: "Full-stack apps that go from idea to production — React front-ends, Python back-ends, and the automation glue in between.",
  },
  {
    n: "02",
    title: "AI & Agents",
    tag: "Automate / Assist",
    body: "Agentic and OCR-driven tools that understand Hindi and English, built for people who don't want to learn new software.",
  },
  {
    n: "03",
    title: "Digital Marketing",
    tag: "Reach / Grow",
    body: "Google-certified in Digital Marketing & E-commerce — turning products into audiences, and audiences into users who stick.",
  },
];

export const WORK = [
  {
    title: "MedVoice",
    pitch: "Free, voice-first billing & inventory web app for Indian pharmacies — GST-ready bills, prescription scan, WhatsApp receipts and refill reminders.",
    stack: ["Voice AI", "GST Billing", "Pharmacy"],
    url: "https://handwrite-sign-off.preview.emergentagent.com/",
  },
  {
    title: "PharmaOrder",
    pitch: "Distributor order automation — Excel import/export and one-tap WhatsApp sharing.",
    stack: ["Automation", "Excel", "WhatsApp"],
  },
  {
    title: "PharmaIntake",
    pitch: "Electron desktop app with OCR bill scanning and a local SQLite inventory.",
    stack: ["Electron", "OCR", "SQLite"],
  },
];
